import { render, staticRenderFns } from "./create-or-update.vue?vue&type=template&id=0c1433cf&scoped=true"
import script from "./create-or-update.vue?vue&type=script&lang=js"
export * from "./create-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1433cf",
  null
  
)

export default component.exports